import React from 'react';
import request from 'superagent';

import Feature from './Feature';
import Features from './Features';
import Recent from './Recent';
import Single from './Single';
import Footer from '../Footer';

class LandingPage extends React.Component{

	constructor() {
		super();

    this.state = {
			windowWidth: window.innerWidth,
      footerHide : true
		};
	}

  handleResize() {
    this.setState({
      windowWidth: window.innerWidth
    });
  }

  loadData(){
		request
			.get('https://wsjnewsgraphics.s3.amazonaws.com/projects/landing-page/latest.json')
			.end(function(err, res){
	      this.setState({
		    	featured: res.body.featured,
	        recent: res.body.recent,
          footerHide: false
		    });
			}.bind(this));
	}

  componentDidMount() {
    this.loadData();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  componentWillUnmount() {
    this.setState({
      footerHide : true
    })
  }

	render() {
    let feature, features, recent, single, footer;

		if(this.state.windowWidth > 1200) { /* breakpoint --> large */

	      if(this.state.featured){
	          feature = <Feature project={ this.state.featured.slice(0,1) }/>;
	      }

	      if(this.state.recent){
	          recent = <Recent projects={ this.state.recent }/>;
	      }

	      if(this.state.featured){
	          features = <Features projects={ this.state.featured.slice(1, this.state.featured.length) }/>;
	      }

		} else {

        if(this.state.recent){
            let items = this.state.recent
                .concat(this.state.featured)
                .sort((a,b) => {
	                  return a.create_date > b.create_date ? -1 : a.create_date < b.create_date ? 1 : 0;
                });

            single = <Single projects={ items }/>;
        }

		}

    footer = <Footer hide={ this.state.footerHide } />

    return (
        <div className={this.props.params.style}>
            { feature }
            { recent }
            { features }
            { single }
            { footer }
        </div>
		);
	}

};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage/index.js